import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { getEvents } from '../../actions/CalendarActions';
import FileNotFound from '../FileNotFound';
import LoadingPage from '../LoadingPage';

const AgendaWidget = () => {
  const [ready, setReady] = useState(false);
  const user = useSelector(state => state.app.user);
  const events = useSelector(state => state.calendar.events) || [];
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getEvents()).then(() => setReady(true));
  }, []);

  const currentDate = moment();

  const getEventDateTime = event => {
    const startDateFormat = moment(event.start_date, 'YYYY-MM-DD HH:mm');
    const endDateFormat = moment(event.end_date, 'YYYY-MM-DD HH:mm');

    // if event is today
    if (moment().isSame(moment(startDateFormat), 'day')) {
      return startDateFormat.format('LT');
    }

    if (moment(currentDate).isBetween(startDateFormat, endDateFormat, 'day', '[]')) {
      return (
        <>
          {startDateFormat.format('MM/DD LT')} - {endDateFormat.format('MM/DD LT')}
        </>
      );
    }

    return null;
  };

  const renderEvents = () => {
    const eventRows = [];

    events.forEach(value => {
      if (parseInt(value.branch) !== parseInt(user.branch.id)) {
        return;
      }

      const eventDateTime = getEventDateTime(value);

      if (!eventDateTime) {
        return;
      }

      eventRows.push(
        <Link
          key={value.id}
          to={`/SDC0/${value.id}`}
          className="dashboard-link agenda"
          style={{ borderLeftColor: value.color }}
        >
          <div>
            <div
              className="badge float-right"
              style={{ color: value.textColor, backgroundColor: value.color, borderRadius: '0px 0px 0px 5px' }}
            >
              {value.templateName}
            </div>
            {value.text}
          </div>
          <div style={{ display: 'flex', fontSize: '90%' }}>
            <div style={{ flex: 1 }}>{eventDateTime}</div>
            <div style={{ flex: 1 }}>
              {value.userName} - {value.customerId}
            </div>
          </div>
        </Link>
      );
    });

    if (!eventRows.length) {
      eventRows.push(
        <FileNotFound key="404">
          Nothing is scheduled for today
          <br />
          <Link to="/SDC0">Schedule an appointment</Link>
        </FileNotFound>
      );
    }

    return eventRows;
  };

  return (
    <div style={{ color: '#333333', overflow: 'auto', height: '100%' }}>{ready ? renderEvents() : <LoadingPage />}</div>
  );
};

export default AgendaWidget;
